import { useMutation, useQueryClient } from '@tanstack/react-query';

import { IndexFieldGateway } from '../gateways';
import { NotificationActionType } from '../reducers/action-types';
import { useNotificationContext } from '../context';
import SuccessNotification from '../components/notifications/success';
import { handleResponse } from '@/core/utils/response';
import { indexFieldKeyFactory } from '@/core/query-keys';

interface MutationProps {
  id: string;
}

async function restoreIndexField({ id }: MutationProps) {
  return handleResponse(IndexFieldGateway.restore({ id }));
}

export function useRestoreIndexField() {
  const client = useQueryClient();
  const { dispatch } = useNotificationContext();

  const successNotification = (name: string) => (
    <SuccessNotification
      title="Restored"
      onClose={() => {
        dispatch({ type: NotificationActionType.ClosePanel });
      }}
    >
      <p>Index field {name} was restored.</p>
    </SuccessNotification>
  );

  return useMutation(restoreIndexField, {
    onSuccess: ({ name }) => {
      client.invalidateQueries(indexFieldKeyFactory.all);
      dispatch({
        type: NotificationActionType.OpenPanel,
        payload: { component: successNotification(name) }
      });
    }
  });
}
